import { useState } from 'react';
import { $t } from 'hooks/i18n';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { Title } from 'components/Title';

import SavingCover from './SavingCover'
export default function SavingcoverPage() {
	
	const [pageReady, setPageReady] = useState(true);
	const [accountnumber, setAccountNumber] = useState('');
	return (
		<main id="SavingcoverPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title={$t('savingcover')}   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <div className="md:col-6 col-12">
                        <div className="formgrid grid">
                            <div className="col-12 md:col-3">
                                {$t('accountnumber')} *
                            </div>
                            <div className="col-12 md:col-9">
                                <DataSource apiPath="components_data/accountnumber_option_list">
                                    {({ response }) => {
                                    const dropdownOptions = response?.map(x => ({
                                    label: x.accountnumber || x.label,
                                    value: x.accountnumber || x.value
                                    })) || [];
                                    return (
                                    <Dropdown
                                    value={accountnumber}
                                    onChange={(e) => setAccountNumber(e.value)}
                                    options={dropdownOptions}
                                    optionLabel="label"
                                    optionValue="value"
                                    filter
                                    showClear
                                    />
                                    );
                                    }}
                                </DataSource>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="">
                    <div><SavingCover accountnumber= {accountnumber} /></div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
